var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBareMetalHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5505_140424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 18.3333H5.83334C4.45251 18.3333 3.33334 17.2141 3.33334 15.8333V4.16663C3.33334 2.78579 4.45251 1.66663 5.83334 1.66663H14.1667C15.5475 1.66663 16.6667 2.78579 16.6667 4.16663V15.8333C16.6667 17.2141 15.5475 18.3333 14.1667 18.3333Z",
    fill: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 16.6667C10.9205 16.6667 11.6667 15.9205 11.6667 15C11.6667 14.0796 10.9205 13.3334 10 13.3334C9.07957 13.3334 8.33337 14.0796 8.33337 15C8.33337 15.9205 9.07957 16.6667 10 16.6667Z",
    fill: "url(#paint0_linear_5505_140424)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 6.66663H6.66668C6.20668 6.66663 5.83334 6.29329 5.83334 5.83329V4.99996C5.83334 4.53996 6.20668 4.16663 6.66668 4.16663H13.3333C13.7933 4.16663 14.1667 4.53996 14.1667 4.99996V5.83329C14.1667 6.29329 13.7933 6.66663 13.3333 6.66663Z",
    fill: "url(#paint1_linear_5505_140424)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 10.8334H6.66668C6.20668 10.8334 5.83334 10.46 5.83334 10V9.16671C5.83334 8.70671 6.20668 8.33337 6.66668 8.33337H13.3333C13.7933 8.33337 14.1667 8.70671 14.1667 9.16671V10C14.1667 10.46 13.7933 10.8334 13.3333 10.8334Z",
    fill: "url(#paint2_linear_5505_140424)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5505_140424",
    x1: 10,
    y1: 13.3334,
    x2: 10,
    y2: 16.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5C7F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C77F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5505_140424",
    x1: 10,
    y1: 4.16663,
    x2: 10,
    y2: 6.66663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5C7F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C77F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5505_140424",
    x1: 10,
    y1: 8.33337,
    x2: 10,
    y2: 10.8334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5C7F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C77F9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5505_140424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBareMetalHover);
export default __webpack_public_path__ + "static/media/bare-metal-hover.a0a9f2c44abe92eecc63fb46770230da.svg";
export { ForwardRef as ReactComponent };